"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GapStyles;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function GapStyles(_ref) {
  let {
    blockGap,
    clientId
  } = _ref;
  const styleElement = (0, _element.useContext)(_blockEditor.BlockList.__unstableElementContext); // --gallery-block--gutter-size is deprecated. --wp--style--gallery-gap-default should be used by themes that want to set a default
  // gap on the gallery.

  const gapValue = blockGap ? blockGap : `var( --wp--style--gallery-gap-default, var( --gallery-block--gutter-size, var( --wp--style--block-gap, 0.5em ) ) )`;
  const gap = `#block-${clientId} { 
		--wp--style--unstable-gallery-gap: ${gapValue};
		gap: ${gapValue} 
	}`;

  const GapStyle = () => {
    return (0, _element.createElement)("style", null, gap);
  };

  return gap && styleElement ? (0, _element.createPortal)((0, _element.createElement)(GapStyle, null), styleElement) : null;
}
//# sourceMappingURL=gap-styles.js.map